module.exports = __webpack_public_path__ + "img/mantaCuraConcreto1.315717de.png";